import React from 'react';
import * as cls from './how-you-benefit.module.css';
import { IMG_PATH } from '../../../../constants';
import { Section } from '../../../../ui/components/section';
import { Typography } from '../../../../ui/components/typography';

const items = [
  {
    title: 'Lower cost-to-serve',
    text: 'by reducing high-bill contacts and improving first-contact resolution.',
  },
  {
    title: 'Higher MAU and session depth',
    text: 'with appliance-level journeys designed to drive repeat engagement.',
  },
  {
    title: 'Better targeting and measurement',
    text: 'for EVs, heat pumps, efficient appliances and tariff initiatives.',
  },
];

export const HowYouBenefit = () => {
  return (
    <Section classNameRoot={cls.section}>
      <Typography as="h1" tag="h2">
        How You Benefit
      </Typography>

      <div className={cls.wrapper}>
        {items.map((item, index) => (
          <div key={index} className={cls.item}>
            <img
              alt=""
              src={`${IMG_PATH}/our-technology/energy-intelligence/how-you-benefit-${index + 1}.svg`}
            />
            <div>
              <Typography tag="h3">{item.title}</Typography>
              <Typography>{item.text}</Typography>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
};
